
angular.module('bmsApp.directives').controller('ComplaintListCtrl', ['$scope', '$log', 'ComplaintSvc', '$window', function ($scope, $log, ComplaintSvc, $window) {

		$scope.objectReady = false;
		$scope.complaints = {
			itemsPerPage: 5,
			loading: true,
			totalCount: 0, // total count of complaints belongs to object
			currentPage: 1,
			pageResult: [] // currently loaded paged results
		};

		// Full complaints

		$scope.$on('showComplaints', function () {
			$scope.loadComplaints($scope.objectType, $scope.objectId);
		});

		$scope.loadComplaints = function (objectType, objectId) {
			if($scope.objectReady) {
				$scope.complaints.loading = true;
				var indexByObjectParams = {
					count: $scope.complaints.itemsPerPage,
					page: $scope.complaints.currentPage,
					objectType: objectType,
					objectId: objectId
				};
				ComplaintSvc.indexByObject(indexByObjectParams)
					.then(function (response) {
						$scope.complaints.pageResult = response.data.complaint_collection;
						$scope.complaints.totalCount = response.data.complaint_total_count;
						$scope.complaints.loading = false;
					}, function (error) {
						$log.error(error);
						$scope.complaints.loading = false;
					});
			}
		};

		$scope.complaintFullView = function () {
			$scope.complaints.currentPage = 1;
			$scope.loadComplaints($scope.objectType, $scope.objectId);
		};

		// Complaint attachments

		// $scope.loadComplaintAttachments = function (objectType, objectId) {
		// 	// use the complaint service without a page size and extract the attachments from there
		// 	$scope.complaintAttachments.loading = true;
		// 	if ($scope.objectReady) {
		// 		var indexByObjectParams = {
		// 			page: 1,
		// 			objectType: objectType,
		// 			objectId: objectId
		// 		};
		// 		ComplaintSvc.indexByObject(indexByObjectParams)
		// 			.then(function (response) {
		// 				var complaintAttachments = [];
		// 				angular.forEach(response.data.complaint_collection, function (complaintCollection) {
		// 					angular.forEach(complaintCollection.complaint_attachments, function (complaintAttachment) {
		// 						complaintAttachments.push(complaintAttachment);
		// 					});
		// 				});
		// 				$scope.complaintAttachments.result = complaintAttachments;
		// 				$scope.complaintAttachments.loading = false;
		// 		}, function (error) {
		// 			$log.error(error);
		// 			$scope.complaintAttachments.loading = false;
		// 		});
		// 	}
		// };


		$scope.$on('complaintUpdated', function () {
			$scope.complaints.currentPage = 1;
			$scope.loadComplaints($scope.objectType, $scope.objectId);
		});

		$scope.complaintsPageChanged = function () {
			$scope.loadComplaints($scope.objectType, $scope.objectId);
		};

		$scope.$watchGroup(['objectType', 'objectId'], function (newValues, oldValues) {
			var objectType = newValues[0];
			var objectId = newValues[1];
			if (angular.isString(objectType) && angular.isNumber(objectId)) {
				$scope.objectReady = true;
			}
			else {
				$scope.objectReady = false;
			}
		});

		$scope.downloadAttachment = function(filename) {
			$window.open('file/download/'+filename, '_blank');
		}

}]);
